import { render, staticRenderFns } from "./ItemListGalleryMyLayout.vue?vue&type=template&id=0f24e2dd&scoped=true"
import script from "./ItemListGalleryMyLayout.vue?vue&type=script&lang=js"
export * from "./ItemListGalleryMyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24e2dd",
  null
  
)

export default component.exports